import { render, staticRenderFns } from "./MultiSearchModule.vue?vue&type=template&id=5f3cab9a&scoped=true"
import script from "./MultiSearchModule.vue?vue&type=script&lang=js"
export * from "./MultiSearchModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3cab9a",
  null
  
)

export default component.exports